import SelectedProductsListSkeleton from './SelectedProductsListSkeleton';

export default SelectedProductsListSkeleton;
